import * as axios from 'axios'

function createClient() {
    return apigClientFactory.newClient({
        apiKey: "Nz2Zez5ETq5e6A1u5fNZ3utmWAAN4lAahRrqXvPj"
    })
}

function searchPartidos(division, torneo, jornada) {
    let apiClient = createClient()

    let params = {
        idDivision: division,
        idTorneo: torneo,
        idJornada: jornada
    }
    return apiClient.idDivisionIdTorneoIdJornadaPartidosGet(params)
}




function searchPartidosAxios(torneo, division, jornada) {
    let apiClient = createClient()

    let params = {
        idDivision: division,
        idTorneo: torneo,
        idJornada: jornada
    }
    return apiClient.idDivisionIdTorneoIdJornadaPartidosGet(params)
}

function searchLineup(idPartido) {
    let apiClient = createClient()

    let params = {
        idPartido: idPartido
    }
    return apiClient.alineacionesIdPartidoGet(params)
}

function searchInformeArbitral(idPartido) {
    let apiClient = createClient()

    let params = {
        idPartido: idPartido
    }
    return apiClient.mxmInformeArbitralIdPartidoDatosPartidoGet(params)
}

function searchJornadasAxios(torneo, division) {
    let apiClient = createClient()

    let params = {
        idDivision: division,
        idTorneo: torneo
    }
    return apiClient.idDivisionIdTorneoJornadasGet(params)
}


function loadDatosPartido(idPartido) {
    let apiClient = createClient()

    let params = {
        idPartido: idPartido,
        size: "",
        page: ""
    }
    return apiClient.mxmInformeArbitralInformeArbitralGet(params)
}

function loadDatosClub(idClub) {
    let apiClient = createClient()

    let params = {
        idClub: idClub,
        size: "",
        page: ""
    }
    return apiClient.clubDatosClubGet(params)
}




function searchAlineacion(idPartido) {
    let apiClient = createClient()

    let params = {
        idPartido: idPartido
    }
    return apiClient.alineacionesIdPartidoGet(params)
}


function loadTeamsAxios(torneo, division) {
    let apiClient = createClient()

    let params = {
        idDivision: division,
        idTorneo: torneo
    }
    return apiClient.idDivisionIdTorneoClubesGet(params)
}


function loadPlantel(idDivision, idClub) {
    let apiClient = createClient()

    let params = {
        idDivision: idDivision,
        idClub: idClub
    }
    return apiClient.idDivisionPlantelIdClubGet(params)
}

function searchNews(idRelacion, idExterno) {
    let apiClient = createClient()

    let params = {
        idExterno: '',
        idRelacion: '',
        fechaFin: '',
        fechaInicio: '',
        palabraClave: 'citec',
        tipoRelacion: '',
        idSeccion: '',
        idNoticia: '',
        top: ''
    }
    return apiClient.noticiasNoticiasLigeroGet(params)
}

function searchPlayerData(idJugador) {
    let apiClient = createClient()

    let params = {
        idAfiliado: idJugador,
        trnoCrto: '',
        fase: '',
        top: '',
        page: '',
        trnoIntr: '',
        idDivision: '',
        size: ''
    }
    return apiClient.afiliadoHistoricoTorneosJugadorGet(params)
}

function loadGeneralStatistics(division, temporada, torneo) {
    let apiClient = createClient()

    let params = {
        idTorneo: torneo,
        idTemporada: temporada,
        idDivision: division,
        Filial: '',
        idGrupo: '',
        page: '',
        Orden: '',
        size: ''
    }
    return apiClient.tablasGeneralGet(params)
}

function loadEstadio(idClub, idEstadio) {
    let apiClient = createClient()

    let params = {
        idClub: idClub,
        idEstadio: idEstadio,
        page: '',
        size: '',
    }
    return apiClient.clubEstadioGet(params)
}

function loadDetalleNoticia(idNoticia) {
    let apiClient = createClient()

    let params = {
        idExterno: '',
        idRelacion: '',
        fechaFin: '',
        fechaInicio: '',
        palabraClave: '',
        apellidoPaternoJugador: '',
        nombreJugador: '',
        idClub1: '',
        apellidoMaternoJugador: '',
        size: '',
        idPartido: '',
        idNewshome: '',
        idClub2: '',
        page: '',
        tipoRelacion: '',
        idSeccion: '',
        idNoticia: idNoticia,
        top: ''
    }
    return apiClient.noticiasBusquedaNoticiasGet(params)
}

function searchMorePlayerData(idJugador) {
    let apiClient = createClient()

    let params = {
        idAfiliado: idJugador
    }
    return apiClient.afiliadoDatosgeneralesGet(params)

    //return axios.get('//liga.apilmx.com/v1/afiliado/datosAfiliado?idAfiliado=' + idJugador + '&fase=1')
}

function loadPartidosProx(temporada, torneo, division, club, instanse) {
    let apiClient = createClient()

    let params = {
        idTemporada: temporada,
        idTorneo: torneo,
        idClub: club,
        idDivision: division,
        page: '',
        size: ''
    }
    return apiClient.clubPartidosProximosGetRequest(params)

    //return  instanse.$http.get('//4sbz0qioc8.execute-api.us-east-1.amazonaws.com/api_ligamx/api_ligamx/partidos/anterioresproximos/' + temporada + '/' + torneo + '/' + division + '/' + club + '/club')
}

function loadPartidosAnteriores(temporada, torneo, division, club, instanse) {
    let apiClient = createClient()

    let params = {
        idTemporada: temporada,
        idTorneo: torneo,
        idClub: club,
        idDivision: division,
        page: '',
        size: ''
    }
    return apiClient.clubPartidosAnterioresGet(params)
        //return  instanse.$http.get('//4sbz0qioc8.execute-api.us-east-1.amazonaws.com/api_ligamx/api_ligamx/partidos/anterioresproximos/' + temporada + '/' + torneo + '/' + division + '/' + club + '/club')
}

function searchCurrentJornadaByDivision(division) {

    let apiClient = createClient()

    let params = {
        idDivision: division,
        page: '',
        size: ''
    }
    return apiClient.jornadasJornadaActualGet(params)

    // return axios.get('//liga.apilmx.com/v1/jornadas/jornadaActual?idDivision=' + division)
}

function searchCurrentTorneoByDivision(division) {

    let apiClient = createClient()

    let params = {
        idDivision: division,
        page: '',
        size: ''
    }
    return apiClient.idDivisionTemporadaTorneoActualGet(params)

    // return axios.get('//siid.ligamx.net/webservices/WS_common_SelectJSON.aspx?psWidget=SIID_TmprTrnoCmpt&objPrAc_IDDivision=' + division)
}


function loadCuerpoTecnico(idClub) {

    let apiClient = createClient()

    let params = {
        idClub: idClub,
        page: '',
        size: ''
    }
    return apiClient.clubCuerpoTecnicoGet(params)

    // return axios.get('//liga.apilmx.com/v1/club/cuerpoTecnico?size=600&idClub='+idClub)
}

function loadUltimoPartidoJugador(idAfiliado) {
    let apiClient = createClient()

    let params = {
        idAfldDrvd: idAfiliado
    }
    return apiClient.afiliadoIdAfldDrvdUltimoPartidoGet(params)

}


/*----------Servicios GOLSTATS----------------*/

function obtenerParadoTacticoAxios(idPartido) {
    return axios.get('https://citec.futbol/apigw/v1/CITEC-IAD360/SEARCH-LINEUPS?MATCH=' + idPartido)
}

async function loadDatosPrevioGolStats(idPartido) {
    return (axios.get('//fmf-services.golstats.com/previous-data?extgameid=' + idPartido)
        .then(resp => resp.data))
}

function getMXMAxios(idPartido) {
    return axios.get("https://citec.futbol/apigw/v1/CITEC-IAD360/MINUTE-TO-MINUTE-SHOW-GAME?MATCH=" + idPartido)
}

async function getGolstatsPositions(idPartido) {
    return (axios.get('//tracking-live-services.azurewebsites.net/read/' + idPartido)
        .then(resp => resp.data))
}

async function obtenerParadoTactico(idPartido) {
    return (axios.get('https://citec.futbol/apigw/v1/CITEC-IAD360/SEARCH-LINEUPS?MATCH=' + idPartido)
        .then(resp => resp.data.Result))
}

async function searchPlays(idPartido) {
    return (axios.get("https://citec.futbol/apigw/v1/CITEC-IAD360/SEARCHPLAYS?MATCH=" + idPartido)
        //  return (axios.get("../data/coordenadasCancha.json")
        .then(resp => resp.data.Result))
}


/**********************CITEC-SERVICES*************************************/

function obtenerParametrosActivosDivision(division) {
    return axios.get('https://citec-functions.azurewebsites.net/api/parametrosactivos?division=' + division)
}


function obtenerTopClub(torneo, division, club) {
    return axios.get(`https://citec-functions.azurewebsites.net/api/jugadorTopVariable?torneo=${torneo}&division=${division}&club=${club}&top=Goles`)
}


export {

    searchPartidos,
    searchPartidosAxios,
    //loadParametrosPartido,
    loadDatosPartido,
    loadDatosPrevioGolStats,
    searchAlineacion,
    getMXMAxios,
    getGolstatsPositions,
    obtenerParadoTacticoAxios,
    obtenerParadoTactico,
    searchPlays,
    searchJornadasAxios,
    searchNews,
    searchLineup,
    searchInformeArbitral,
    searchPlayerData,
    searchMorePlayerData,
    searchCurrentJornadaByDivision,
    searchCurrentTorneoByDivision,
    loadGeneralStatistics,
    loadTeamsAxios,
    loadPartidosProx,
    loadPartidosAnteriores,
    loadCuerpoTecnico,
    loadEstadio,
    loadPlantel,
    loadDetalleNoticia,
    loadUltimoPartidoJugador,
    loadDatosClub,
    obtenerParametrosActivosDivision,
    obtenerTopClub
}